import { REPORT_TYPES_SLOT } from './relatorios'

export default [
  {
    key: 'dashboard',
    icon: 'mdi-view-dashboard',
    title: 'Dashboard',
    to: '/admin/dashboard',
  },
  {
    key: 'dashboardConsultor',
    icon: 'mdi-account-box',
    title: 'Consultor dashboard',
    to: 'dashboardConsultor',
  },
  {
    key: 'agroindustrias',
    icon: 'mdi-factory',
    title: 'Agroindústrias/Filial',
    to: '/admin/agroindustrias',
  },
  {
    key: 'cronograma-financeiro-grupo',
    icon: 'mdi-cash',
    title: 'Cronograma Financeiro',
    group: '/admin',
    children: [
      {
        key: 'financeiro',
        icon: 'mdi-account-hard-hat',
        title: 'Cronograma Financeiro',
        to: 'financeiro',
      },
      {
        key: 'financeiros',
        icon: 'mdi-account-hard-hat',
        title: 'Cronograma por consultor',
        to: 'financeiros',
      },
      {
        key: 'odometer',
        icon: 'mdi-car',
        title: 'Lançamento de percurso',
        to: 'odometer',
      },
    ],
  },
  {
    key: 'pessoas-grupo',
    icon: 'mdi-account-multiple',
    title: 'Pessoas',
    group: '/admin',
    children: [
      {
        key: 'consultores',
        icon: 'mdi-account-hard-hat',
        title: 'Consultores',
        to: 'consultores',
      },
      {
        key: 'consultancy',
        icon: 'mdi-account-star',
        title: 'Consultoria',
        to: 'consultancy',
      },
      {
        key: 'central',
        icon: 'mdi-account-cog',
        title: 'Supervisor',
        to: 'central',
      },
      {
        key: 'fazendas',
        icon: 'mdi-home-flood',
        title: 'Fazendas',
        to: 'fazendas',
      },
      {
        key: 'gestores',
        icon: 'mdi-account-tie',
        title: 'Gestores',
        to: 'gestores',
      },
      {
        key: 'prestador',
        icon: 'mdi-account',
        title: 'Prestadores',
        to: 'prestador',
      },
      {
        key: 'produtores',
        icon: 'mdi-account-cowboy-hat',
        title: 'Produtores',
        to: 'produtores',
      },
    ],
  },
  {
    key: 'agenda',
    icon: 'mdi-calendar-month',
    title: 'Agenda',
    to: '/admin/schedules',
  },
  {
    key: 'relatorios-grupo',
    icon: 'mdi-clipboard-list',
    title: 'Relatórios',
    group: '/admin/relatorios',
    children: [
      {
        key: 'visitas-grupo',
        subicon: 'mdi-clipboard-list',
        title: 'Visitas',
        group: '/admin/relatorios',
        children: [
          REPORT_TYPES_SLOT,
          {
            key: 'entregas',
            icon: 'mdi-clipboard-multiple',
            title: 'Entregas de Material',
            to: 'entregas',
          },
        ],
      },
      {
        key: 'gerenciais-grupo',
        title: 'Gerenciais',
        group: '/admin/relatorios',
        children: [
          {
            key: 'visitas',
            icon: 'mdi-file-document-edit',
            title: 'Visitas por Consultor',
            to: 'visitas',
          },
          {
            key: 'entrega',
            icon: 'mdi-file-document-edit',
            title: 'Entrega de Material',
            to: 'entrega',
          },
          {
            key: 'deslocamento',
            icon: 'mdi-clipboard-list',
            title: 'Deslocamento de Consultores',
            to: 'deslocamento',
          },
          {
            key: 'sinc',
            icon: 'mdi-clipboard-list',
            title: 'Sincronização de Visitas',
            to: 'sinc',
          },
          {
            key: 'localizacao',
            icon: 'mdi-home-search',
            title: 'Localização das Propriedades',
            to: 'localizacao',
          },
          {
            key: 'farmDistribution',
            icon: 'mdi-home-map-marker',
            title: 'Distribuição de fazendas',
            to: 'farmDistribution',
          },
          {
            key: 'report-create',
            icon: 'mdi-folder-plus',
            title: 'Relatórios',
            to: 'report/create',
          },
          {
            key: 'report-extract',
            icon: 'mdi-database-export',
            title: 'Extração de dados',
            to: 'report/extract',
          },
        ],
      },
    ],
  },
]
